export function toggleSelectedService(prevSelected, itemCode, buildEntry) {
	const isAlreadySelected = prevSelected.some(
		(service) => service.itemCode === itemCode,
	)

	if (isAlreadySelected) {
		return prevSelected.filter((service) => service.itemCode !== itemCode)
	}

	return [...prevSelected, buildEntry()]
}
